import API_BASE_URL from '../Config';

export const getParentescos = async (token) => {
    const response = await fetch(`${API_BASE_URL}/parentescos`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    if (!response.ok) throw new Error('Error al cargar parentescos');
    return response.json();
};

export const getParentescosPaginadas = async (token, page = 0, size = 10, search = '') => {
    const params = new URLSearchParams({
        page: page.toString(),
        size: size.toString(),
        search: search
    });

    const response = await fetch(`${API_BASE_URL}/parentescos/page?${params.toString()}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    if (!response.ok) throw new Error('Error al cargar parentescos paginadas');
    return response.json();
};

export const getParentescoById = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/parentescos/${id}`, {
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    if (!response.ok) throw new Error('Error al cargar el parentesco');
    return response.json();
};

export const createParentesco = async (token, parentescoData) => {
    const response = await fetch(`${API_BASE_URL}/parentescos`, {
        method: 'POST',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(parentescoData)
    });
    if (!response.ok) throw new Error('Error al crear parentesco');
    return response.json();
};

export const updateParentesco = async (token, id, parentescoData) => {
    const response = await fetch(`${API_BASE_URL}/parentescos/${id}`, {
        method: 'PUT',
        headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(parentescoData)
    });
    if (!response.ok) throw new Error('Error al actualizar parentesco');
    return response.json();
};

export const deleteParentesco = async (token, id) => {
    const response = await fetch(`${API_BASE_URL}/parentescos/${id}`, {
        method: 'DELETE',
        headers: {
            'Authorization': `Bearer ${token}`
        }
    });
    if (!response.ok) throw new Error('Error al desactivar parentesco');
    return response.json();
};
